'use client';
import { environmentHeaders } from '@addava/domain/environment';
import { createBrowserClient } from '@supabase/ssr';
import type { Database } from '@addava/domain/database.types';
export function useSupabase() {
  return createBrowserClient<Database>(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    { global: { headers: environmentHeaders(process.env.NEXT_PUBLIC_ADDAVA_ENVIRONMENT) } },
  );
}
